import { Col, Row } from 'antd'
import HoldBlackIcon from 'components/TableStyles/TableStylesSqare/Absent.svg'
import Scheduled from 'components/TableStyles/TableStylesSqare/Scheduled.svg'
import { VectorLeft } from 'modules/Drives/Components/Styles/style'
import React from 'react'
import styled from 'styled-components'
import GoNext from '../../../../../components/TableStyles/TableStylesSqare/GoNext.svg'
import Hold from '../../../../../components/TableStyles/TableStylesSqare/Hold.svg'
import Rejected from '../../../../../components/TableStyles/TableStylesSqare/Rejected.svg'
import VectorRed from '../../../../../components/TableStyles/TableStylesSqare/VectorLeft.svg'

function DropdownCard({ data }) {
  const CardHover = styled.div`
    padding: 15px;
    background: #fff;
    position: absolute;
    z-index: 9999;
    transform: translate(16px, 0px);
    top: 6px;
    width: 330px;
    height: 120px;
    box-shadow: 10px 10px 10px gainsboro;
    overflow: auto;
  `
  const status = data => {
    let statusData = {
      status: '',
      color: '',
      img: '',
    }

    if (data == 'REJECTED') {
      statusData.status = 'Rejected'
      statusData.color = 'red'
      statusData.img = Rejected
    } else if (data == 'MOVE_TO_NEXT_ROUND') {
      statusData.status = 'Move to next round'
      statusData.color = 'green'
      statusData.img = GoNext
    } else if (data == 'ABSENT') {
      statusData.status = 'Absent'
      statusData.color = 'black'
      statusData.img = HoldBlackIcon
    } else if (data == 'REJECT') {
      statusData.status = 'Reject'
      statusData.color = 'red'
      statusData.img = Rejected
    } else if (data == 'SCHEDULED') {
      statusData.status = 'Scheduled'
      statusData.color = 'black'
      statusData.img = Scheduled
    } else if (data == 'TO_BE_SCHEDULED') {
      statusData.status = 'To be scheduled'
      statusData.color = 'black'
      statusData.img = Scheduled
    } else if (data == 'NOT_RELEASED') {
      statusData.status = 'Intent to offer'
      statusData.color = 'black'
    } else if (data == 'RELEASED') {
      statusData.status = 'Offer released'
      statusData.color = 'black'
    } else if (data == 'ACCEPT') {
      statusData.status = 'accept'
      statusData.color = 'black'
    } else if (data == 'RESCHEDULE') {
      statusData.status = 'Reschedule'
      statusData.color = 'black'
    } else {
      statusData.status = 'Held to compare'
      statusData.color = 'yellow'
      statusData.img = Hold
    }

    return statusData
  }

  return (
    <CardHover>
      <VectorLeft src={VectorRed} />
      {data?.map((item, index) => (
        <div style={{ marginBottom: '1em' }} key={index + 'hoverCard'}>
          <Row style={{ fontSize: '12px', fontWeight: '500' }}>
            <Col span={10} align="left">
              {item.interviewer_details.firstName +
                ' ' +
                item.interviewer_details.lastName}
            </Col>
            {status(item?.status)?.img ? (
              <Col span={4} align="center">
                <img src={status(item?.status)?.img} alt="statusImg" />
              </Col>
            ) : (
              <Col span={2} align="center"></Col>
            )}
            <Col align="left" span={10}>
              {status(item?.status)?.status}
            </Col>
          </Row>
          {item?.feedback && (
            <Row
              style={{
                marginBottom: '1em',
                marginTop: '0.5em',
                fontSize: '10px',
              }}
            >
              <Col span={1}>
                <div
                  style={{
                    borderLeft: `3px solid ${status(item?.status)?.color}`,
                    height: '1.3em',
                    top: '2px',
                    position: 'absolute',
                  }}
                ></div>
              </Col>
              <Col span={23}>{item?.feedback}</Col>
            </Row>
          )}
        </div>
      ))}
    </CardHover>
  )
}

export default DropdownCard
